import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { API_BASE_URL } from "../../config/config";
import SalesTrendHeader from "../../Pages/SalesTrendHeader";
// import StockistFilter from "./component/stockistFilter";
// import StockistDataComp from "./component/StockistDataComp";
// import StockistTable from "./component/StockistTable";
import React from "react";
import DashboardFilter from "./DashboardFilter";
import { useTokenFromQuery, useFetchUserDetails, getUserIdFromToken ,useResetRefreshTime } from "../../utils/dashboardUtils.js";
import DashboardTable from "./DashboardTable";


interface DecodedToken {
  name: string;
  preferred_username: string;
}

const DashboardDataComponent: React.FC = () => {
  const [refreshTime, setRefreshTime] = useState<string | null>(null);
  const [userLocation, setUserLocation] = useState<string | null>(null);
  const [headerUsername, setHeaderUsername] = useState<string | null>(null);
  useTokenFromQuery("/app/newdashboard");
  useFetchUserDetails(setUserLocation, setHeaderUsername, setRefreshTime, API_BASE_URL, "Daily_Activity_Summary");
  useResetRefreshTime(setRefreshTime);
  const user_id = getUserIdFromToken();

  // Add months array and selectedMonth state
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth() + 1);

  // Define userRole, update logic as needed
  const [userRole, setUserRole] = useState<string>("");

  // Define activeCard state
  const [activeCard, setActiveCard] = useState<string>("");

  return (
    <div className="activity-trend-dashboard ">
      <div className="dashboard-container">
        <SalesTrendHeader
          title="Daily Activity Summary"
          userName={headerUsername }
          location={userLocation }
          refreshTime={refreshTime}
        />
     <DashboardFilter user_id={user_id} />
     <DashboardTable
       userId={user_id}
     activeCard={activeCard}
        selectedMonth={months[selectedMonth - 1]}
        userRole={userRole}
     />
     
      </div>
    </div>
  );
};

export default DashboardDataComponent;